



























































































































































































































































































































































































import Currency from '@/components/Currency.vue';
import Cantidad from './Cantidad.vue';
export default {
	components: { Cantidad, Currency },
	name: 'carrito',
	inject: ['responsive'],
	props: {
		visible: {
			type: Boolean,
			required: true,
			default: false,
		},
		cardactivo: {
			type: Number,
		},
	},
	data() {
		return {
			pickerOptions: {
				disabledDate: this.disabledDate,
			},
			showAlertPrecio: false,
			//alertaPrecio: [],
			visibleCarrito: false,
			show: false,
			activo: 1,
			loadingConfirm: false,
			loadingCondiciones: false,
			input: '',
			form: {
				entrega: '',
				origen: '',
				operacion: '',
				fecha_entrega: null,
				detalle: '.',
			},
			rules: {
				entrega: [{ required: false, message: 'Ingresar domicilio de entrega' }],
			},
			precio: '',
			dialogVisible: false,
			productoselected: '',
		};
	},
	watch: {
		visible(v) {
			this.show = !this.show;
		},
		cardactivo(v) {
			this.activo = v;
		},
		carrito(v) {
			if (v) this.loading = false;
		},
	},
	computed: {
		posiciones() {
			return this.$store.state.pedidos.posiciones;
		},
		producto() {
			return this.$store.state.pedidos.filter((ele: { id: string }) => ele.id == this.$route.path.slice(13))[0];
		},
		parametros() {
			return this.$store.state.config.parametros;
		},
		origen: {
			get() {
				return this.form.origen === '' ? this.$store.state.pedidos.origen : this.form.origen;
			},
			set(val) {
				this.form.origen = val;
			},
		},
		operacion: {
			get() {
				return this.form.operacion === '' ? this.$store.state.pedidos.operacion : this.form.operacion;
			},
			set(val) {
				this.form.operacion = val;
			},
		},
		entrega: {
			get() {
				return this.form.entrega === '' ? this.$store.state.pedidos.entrega : this.form.entrega;
			},
			set(val) {
				this.form.entrega = val;
			},
		},
		fecha_entrega: {
			get() {
				return this.form.fecha_entrega === null ? this.$store.state.pedidos.fecha_entrega : this.form.fecha_entrega;
			},
			set(val) {
				this.form.fecha_entrega = val;
			},
		},
		carrito() {
			return this.$store.state.pedidos.carrito;
		},
		loading: {
			get() {
				return this.$store.state.pedidos.loadingcarrito;
			},
			set(val) {
				this.$store.state.pedidos.loadingcarrito = val;
			},
		},
		idcarrito() {
			return this.$store.state.pedidos.idcarrito;
		},
		torigen() {
			return this.$store.state.pedidos.torigen;
		},
		toperacion() {
			return this.$store.state.pedidos.toperacion;
		},
		dentregas() {
			return this.$store.state.pedidos.dentregas;
		},
		fdepagos() {
			return this.$store.state.pedidos.fdepagos;
		},
		total() {
			return this.$store.state.pedidos.totalpedido;
		},
		importes() {
			return this.$store.state.pedidos.importes;
		},
		activeHost() {
			return this.$store.state.perfil.activeHost;
		},
		cooperativa() {
			return this.$store.state.config.cuit;
		},
		detallepedido: {
			get() {
				return this.form.detalle === '.' ? this.$store.state.pedidos.detallepedido : this.form.detalle;
			},
			set(val) {
				this.form.detalle = val;
			},
		},
		totales() {
			return this.$store.state.pedidos.totales;
		},
		diasEntrega() {
			return this.$store.state.pedidos.diasentrega;
		},
		alertaPrecio() {
			return this.$store.state.pedidos.alertaprecio || [];
		},
	},
	methods: {
		safeFirstFile(u) {
			try {
				if (!u) return null;

				if (typeof u === 'string') {
					const s = u.trim();
					if (!s) return null;
					if (s[0] === '[') {
						const arr = JSON.parse(s);
						return Array.isArray(arr) && typeof arr[0] === 'string' && arr[0].trim() ? arr[0] : null;
					}
					return s;
				}
				if (Array.isArray(u)) {
					const first = u[0];
					return typeof first === 'string' && first.trim() ? first : null;
				}

				if (typeof u === 'object') {
					if (typeof u[0] === 'string' && u[0].trim()) return u[0];
					if (typeof u.path === 'string' && u.path.trim()) return u.path;
				}
				return null;
			} catch (_) {
				return null;
			}
		},

		buildFileUrl(file) {
			const coop = encodeURIComponent(this.cooperativa);
			const arch = encodeURIComponent(file);
			return `./api/public/proxy/files?cooperativa=${coop}&type=pedidos&archivo=${arch}`;
		},

		imageSrcProd(producto) {
			const f = this.safeFirstFile(producto && producto.url);
			return f ? this.buildFileUrl(f) : '';
		},
		// eliminarAlerta(id) {
		// 	delete this.alertaPrecio[id];
		// 	this.alertaPrecio.splice(id, 1);
		// },
		eliminarAlerta(index) {
			// cloná, modificá y commit
			const next = this.alertaPrecio.slice();
			next.splice(index, 1);
			this.$store.commit('setAlertaPrecio', next);
		},
		disabledDate(time: Date) {
			const date = new Date();
			//const isWeekend = time.getDay() % 6 === 0;
			return time.getTime() < date.getTime() + 3600 * 1000 * 24 * this.diasEntrega;
		},
		updateDetalle() {
			let condiciones = [];
			condiciones['detalle'] = this.detallepedido;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putDetalle', condiciones);
		},
		loadSelect(event: boolean) {
			if (event) this.$store.dispatch('loadDentregas').then(() => {});
		},
		clearEntrega() {
			this.form.entrega = '';
			this.updateEntrega();
		},
		updateEntrega(entrega: number) {
			let condiciones = [];
			condiciones['dentrega'] = entrega ? entrega : this.form.entrega;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putDentrega', condiciones);
		},
		clearOrigen() {
			this.origen = ' ';
			this.updateOrigen();
		},
		updateOrigen(origen: number) {
			let condiciones = [];
			condiciones['origen'] = origen ? origen : this.origen;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putOrigen', condiciones);
		},
		clearOperacion() {
			this.operacion = ' ';
			this.updateOperacion();
		},
		updateOperacion(operacion: number) {
			let condiciones = [];
			condiciones['operacion'] = operacion ? operacion : this.operacion;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putOperacion', condiciones);
		},
		updateFecha() {
			let condiciones = [];
			condiciones['fecha_entrega'] = this.form.fecha_entrega;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putFechaEntrega', condiciones);
		},
		getEmpty() {},
		removeProducto(producto: { producto_id: number; pedido_id: number }) {
			let params = {
				params: {
					id: producto.producto_id,
					pedido_id: producto.pedido_id,
				},
			};

			this.$confirm('El producto será eliminado del carrito. ¿Desea continuar?', 'Confirmación', {
				confirmButtonText: 'Si',
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: true,
				customClass: this.responsive.isMobile ? 'confirm-mobile' : '',
			})
				.then(() => {
					this.loading = true;
					this.eliminarAlerta(producto.producto_id);
					this.$store.dispatch('removeProducto', params).then(() => (this.loading = false));
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: 'Operación cancelada',
					});
				});
		},
		removeAll() {
			// this.alertaPrecio = [];
			this.$store.commit('setAlertaPrecio', []);
			const params = {
				params: {
					pedido_id: this.idcarrito,
				},
			};

			this.$confirm('Se eliminarán todo los productos y condiciones cargadas. ¿Desea continuar?', 'Confirmación', {
				confirmButtonText: 'Si',
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: true,
			})
				.then(() => {
					this.loading = true;
					this.fecha_entrega = '';
					this.entrega = '';
					this.origen = '';
					this.operacion = '';
					this.detallepedido = '';
					this.$store.dispatch('removeAll', params).then(() => (this.loading = false));
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: 'Operación cancelada',
					});
				});
		},
		onClosed() {
			this.show = false;
		},
		onOpen() {
			this.loadingCondiciones = true;
			this.$store.dispatch('loadDentregas').then(entrega => {
				if (entrega.length === 1) {
					this.form.entrega = entrega[0].destino_id;
					this.updateEntrega(entrega[0].destino_id);
				}
				this.loadingCondiciones = false;
			});
			this.$store.dispatch('loadTorigen').then(origen => {
				if (origen.length === 1) {
					this.form.origen = origen[0].origen_id;
					this.updateOrigen(origen[0].origen_id);
				}
				this.loadingCondiciones = false;
			});
		},
		handleClick() {
			//this.activo = ++this.activo;
			/*if (this.activo !== 2 || (this, this.activo === 2 && this.entrega && this.dentregas.length >= 1)) this.activo = ++this.activo;
			else if (this.activo === 2)
				this.$message({
					message: 'Cargar domicilio de entrega.',
					type: 'error',
				});*/
			if (this.activo === 2 && this.parametros.pedidos && this.parametros.pedidos.obliga_tipooperacion === true) {
				if (!this.operacion || this.operacion === ' ') {
					this.$message({
						message: 'Debe seleccionar un tipo de operación.',
						type: 'error',
					});
					return;
				}
			}
			
			this.activo = ++this.activo;
		},
		handleBack() {
			this.activo = --this.activo;
		},
		handleConfirm() {
			this.$confirm('Su pedido será confirmado. ¿Desea continuar?', 'Confirmación', {
				confirmButtonText: 'Si',
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: true,
			})
				.then(() => {
					this.loadingConfirm = true;
					this.$store.dispatch('confirmCarrito', this.idcarrito).then(result => {
						if (result.status === 200) {
							if (result.data.success) {
								this.$router.push('/1/pedidos/');
								//TODO: resetFields form para q lo tome hay q hacer v-show pero igual no puedo hacer andar con computed property
								//this.$refs[form].resetFields();
								this.$store.state.pedidos.carrito = [];
								this.form.entrega = '';
								this.form.origen = '';
								this.form.operacion = '';
								this.form.detalle = '';
								this.form.fecha_entrega = '';
								this.show = false;
								this.activo = 1;
								this.$message({
									type: 'success',
									message: 'Pedido realizado',
								});
								this.loadingConfirm = false;
								this.$store.dispatch('loadCarrito');
							} else this.$message.error('Error, ' + result.data.msg);
						} else this.$message.error({ message: 'Pedido realizado' });

						this.loadingConfirm = false;
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: 'Operación cancelada',
					});
				});
		},
		empty() {
			return true;
		},
		multiply(a: number, b: number) {
			return a * b;
		},
		inputValidator(value) {
			const input = document.querySelector(`#currency`);
			function formatNumber(n) {
				return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
			}
			var input_val = value;
			if (!input_val || input_val === '') return;
			if (input_val.indexOf(',') >= 0) {
				var decimal_pos = input_val.indexOf(',');
				// split number by decimal point
				var left_side = input_val.substring(0, decimal_pos);
				var right_side = input_val.substring(decimal_pos);
				// add commas to left side of number
				left_side = formatNumber(left_side);
				// validate right side
				right_side = formatNumber(right_side);
				// Limit decimal to only 2 digits
				right_side = right_side.substring(0, 2);
				// join number by .
				input_val = '$' + left_side + ',' + right_side;
			} else {
				input_val = formatNumber(input_val);
				input_val = '$' + input_val;
			}
			this.precio = input_val;
		},
		pressKey(event) {
			let key = event.key;
			if (key === 'Unidentified' || key === '.') {
				key = ',';
				this.precio += key;
			}
		},
		confirm() {
			const producto = this.productoselected;
			let value = this.precio.replace('$', '').replace(/\./g, '').replace(/,/g, '.');
			if (
				(producto.precio_final_minimo ? parseFloat(value) < producto.precio_final_minimo : false) ||
				(producto.precio_final_maximo ? parseFloat(value) > producto.precio_final_maximo : false)
			) {
				//agrego alerta al pedido
				let params = {
					params: {
						id: producto.producto_id,
						pedido_id: producto.pedido_id,
					},
				};

				this.$store.dispatch('addAlerta', params);
			} else {
				// elimino la alerta al pedido
				let params = {
					params: {
						id: producto.producto_id,
						pedido_id: producto.pedido_id,
					},
				};
				this.$store.dispatch('deleteAlerta', params);
			}

			producto.precio_final = value;
			this.$store.dispatch('addProducto', producto);
			this.$store.dispatch('loadCarrito');

			this.productoselected = '';
			this.precio = '';
			this.dialogVisible = false;
		},
	},
};
